const ADMIN_HOME_ROUTE = '/dashboard/general-summary'

const ADMIN_ALLOWED_SUBTYPES = ['SUPER_ADMIN_MASTER', 'ADMIN_MASTER', 'GROUP_ADMIN', 'ADMIN', 'MANAGER', 'OPERATOR', 'AUDITOR']

const normalizeString = value => {
    if (value === null || value === undefined) return ''
    return String(value).trim()
}

export const normalizeEmail = value => normalizeString(value).toLowerCase()

const parseAllowedMasterEmails = () => {
    const rawEmails = process.env.VUE_APP_MASTER_ADMIN_EMAILS || process.env.VUE_APP_MASTER_ADMIN_EMAIL || ''

    if (!rawEmails) return []

    return rawEmails
        .split(',')
        .map(item => normalizeEmail(item))
        .filter(Boolean)
}

const getAllowedMasterEmails = () => parseAllowedMasterEmails()

export const resolveUserSubtype = user => normalizeString(user?.companyUser?.subtype).toUpperCase()

export const resolveUserEmail = (user, fallbackEmail = '') => {
    const resolved =
        user?.email ||
        user?.username ||
        user?.systemUser?.email ||
        user?.companyUser?.email ||
        user?.companyUser?.systemUser?.email ||
        fallbackEmail

    return normalizeEmail(resolved)
}

export const isSuperAdminMaster = user => resolveUserSubtype(user) === 'SUPER_ADMIN_MASTER'

export const isGroupAdmin = user => resolveUserSubtype(user) === 'GROUP_ADMIN'

export const isAdminAllowedSubtype = user => ADMIN_ALLOWED_SUBTYPES.includes(resolveUserSubtype(user))

export const isMasterEmailAllowed = (user, fallbackEmail = '') => {
    const allowedEmails = getAllowedMasterEmails()
    if (!allowedEmails.length) return true

    const userEmail = resolveUserEmail(user, fallbackEmail)
    return Boolean(userEmail && allowedEmails.includes(userEmail))
}

export const isAllowedAdminUser = (user, fallbackEmail = '') => {
    const subtype = resolveUserSubtype(user)
    if (!ADMIN_ALLOWED_SUBTYPES.includes(subtype)) return false

    // Email restriction only applies to SUPER_ADMIN_MASTER
    if (subtype === 'SUPER_ADMIN_MASTER') {
        return isMasterEmailAllowed(user, fallbackEmail)
    }

    return true
}

export const isAdminSessionAuthorized = session => {
    if (!session || typeof session.exists !== 'function' || typeof session.get !== 'function') return false
    if (!session.exists('token') || !session.exists('user')) return false

    const token = normalizeString(session.get('token'))
    const user = session.get('user')

    if (!token || !user) return false

    return isAllowedAdminUser(user)
}

export const buildConventionalLoginPayload = credentials => {
    const email = normalizeEmail(credentials?.email)
    return {
        email,
        username: email,
        login: email,
        password: normalizeString(credentials?.password),
    }
}

export const getAdminHomeRoute = () => ADMIN_HOME_ROUTE
